import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';
import { PortPurpose } from '../fields';
import { environmental } from '../component-sections/environmental';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    description: z.string().default(''),
    purpose: PortPurpose.validator,
});

const CombinerBoxBase = z.object({
    type: z.literal('combinerBox').default('combinerBox'),
    electrical: z
        .object({
            ports: z
                .array(port)
                .min(2)
                .default([
                    {
                        powerFlowDirection: 'output',
                    },
                    {
                        powerFlowDirection: 'input',
                    },
                    {
                        powerFlowDirection: 'input',
                    },
                ]),
        })
        .default({}),
    compatibleProducts: z.array(ComponentValidator.shape.id).default([]),
    environmental,
});

export const CombinerBoxValidator = ComponentValidator.merge(CombinerBoxBase);
export const CombinerBoxPayloadValidator = ComponentPayloadValidator.merge(CombinerBoxBase);

export const CombinerBoxDefinition: ComponentDefinition = {
    type: 'combinerBox',
    name: 'Combiner Box',
    plural: 'Combiner Boxes',
    description:
        'A combiner box is a device that combines the output of multiple strings of photovoltaic panels into a single DC output.',
    indicator: 'A',
    hasDynamicNumberOfPorts: true,
    interoperabilityDataModel: false,
    actsAsConverter: false,
    ports: {
        min: 2,
        max: Infinity,
        powerFlowDirections: ['input', 'output'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: CombinerBoxValidator,
        payload: CombinerBoxPayloadValidator,
    },
};

export type CombinerBox = z.infer<typeof CombinerBoxValidator>;
export type CombinerBoxPayload = z.infer<typeof CombinerBoxPayloadValidator>;
